'use strict';

angular.module('footer', [])

.controller('FooterCtrl', [function() {
  var ctrl = this;
  ctrl.currentDate = new Date();
}]);
